'use strict';

const _ = require('lodash');

const OverlayItemController = function ($scope, $rootScope, Flux, NavActions) {

  const vm = this;
  const OverlayStore = Flux.Store.get('OverlayStore');
  const MapActions = Flux.Actions.get('MapActions');

  // Holds the overlay opacity in the slider scale (1-100)
  vm._opacity = 100;

  // Controller may be instantiated after the active annotation has been selected,
  // so read in the initial state as well
  const initialOverlay = OverlayStore.get('active');
  if (initialOverlay) {
    vm.overlay = initialOverlay;
    vm._opacity = (vm.overlay.opacity && (vm.overlay.opacity * 100)) || 100;
  }

  /**
   * Save the overlay
   */
  vm.save =  () => {

    MapActions.SaveActiveOverlay.dispatch();
    // TODO: This should use the `waitFor` functionality of flux model.
    // Use a custom event for now instead
    OverlayStore.once(OverlayStore.Events.ActiveSaved, () => {

      MapActions.EditOverlayEnd.dispatch(true);
    });
  };

  vm.cancel = () => {

    $rootScope.$broadcast('dialog:overlay:confirmCancelEdit');
  };

  // TODO: This is repeated in several navLeft children directives.
  // Refactor to a central place
  vm.closeDrawer = (options) => {

    options = options || {};
    if (options.prompt) {
      $rootScope.$broadcast(options.prompt);
    }
    else {
      NavActions.CloseDrawer.dispatch();
    }
  };

  $scope.$on('dialog:overlay:confirmCancelEdit', () => {

    MapActions.EditOverlayEnd.dispatch(false);
  });

  vm.handleOverlaysChange = () => {

    const activeOverlay = OverlayStore.get('active');
    if (activeOverlay) {
      vm.overlay = activeOverlay;
      vm._opacity = (vm.overlay.opacity && (vm.overlay.opacity * 100)) || 100;
    }
  };

  $scope.$watch(() => {

    return vm._opacity;
  }, (oldValue, newValue) => {

    const ref = 'overlay-' + vm.overlay.id;
    $rootScope.$broadcast('overlay:opacity:changed', ref, newValue / 100);
    MapActions.ChangeOverlayOpacity.dispatch(vm.overlay.id, newValue / 100);
  });

  OverlayStore.on(OverlayStore.Events.Changed, this.handleOverlaysChange.bind(this), $scope);
};

OverlayItemController.$inject = [
  '$scope', '$rootScope', 'sbFlux', 'NavActions'
];
module.exports = OverlayItemController;


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/overlays/item/OverlayItemController.js